import React from 'react';
interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
}
export function Toggle({
  checked,
  onChange,
  label,
  description
}: ToggleProps) {
  return <div className="flex items-start justify-between gap-4" data-id="element-320" data-mp="1qpwh8jnw2zzm">
      <div data-id="element-321" data-mp="1mpmah4s9w5jp">
        <p className="text-sm font-medium text-slate-800" data-id="element-322" data-mp="1mpw3l18m6stm">{label}</p>
        {description && <p className="mt-0.5 text-xs text-slate-500" data-id="element-323" data-mp="1hpzx8vcg2paw">{description}</p>}
      </div>
      <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`relative mt-0.5 inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-900 focus-visible:ring-offset-2 ${checked ? 'bg-brand-700' : 'bg-slate-300'}`} data-id="element-324" data-mp="1hnwy9ltbdlu1">
        <span aria-hidden="true" className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${checked ? 'translate-x-[18px]' : 'translate-x-0.5'}`} data-id="element-325" data-mp="2y49n5twc4m3u" />
      </button>
    </div>;
}